export const version = '1.19.12';
//# sourceMappingURL=version.js.map